import { List, TextField, useTable } from "@refinedev/antd";
import axAPI from "../../../../api/axios-instance";

import { useEffect, useState } from "react";
import { Table } from "antd";
import { v4 as randomId } from "uuid";
import { errorNotification } from "../../../../helpers";
import s from "./LeonB-List.module.scss";
import { MapTeam } from "./Map-Team/Map-Team";
import { useList } from "@refinedev/core";
import { ClubRow } from "../../../Clubs/Lib";

type LeonBRowType = {
  leagueId: number;
  melbetTeam: string;
  teamId?: number;
  teamName?: string;
  teamCity?: string;
};
export const LeonBList = () => {
  const [datasource, setDatasource] = useState<Array<any>>([]);
  const [seasonId, setSeasonId] = useState<number>();
  const [leagueTeam, setLeagueTeam] = useState<
    { title: string; teamId: number; city: string }[]
  >([]);

  const { tableQueryResult } = useTable<any>({
    dataProviderName: "mappingLeonBDataProvider",
    resource: "leon_b",
    syncWithLocation: false,
    meta: {
      leagueId: 300,
    },
    ...errorNotification({
      errorData: {
        errorKeys: [
          {
            errorCode: "typeMismatch",
            message: "Неверное значение при чтении id пользователя",
          },
        ],
      },
    }),
  });

  const { data, refetch: refetchClubs } = useList({
    dataProviderName: "clubsDataProvider",
    meta: { leagueId: 300, seasonId: seasonId },
  });

  useEffect(() => {
    refetchClubs<ClubRow[]>().then(({ data }) => {
      const teams = data?.data.map((team) => {
        return {
          title: team.title,
          teamId: team.teamId,
          city: team.city,
        };
      });
      setLeagueTeam(teams || []);
    });
  }, [seasonId]);

  const fetchData = async () => {
    const { data } = await tableQueryResult.refetch();
    const clubs = data?.data as {
      fnlTeam: string;
      melbetTeam: string;
      leagueId: number;
    }[];

    if (clubs) {
      await setDatasource(clubs);
    }
    return clubs;
  };

  useEffect(() => {
    fetchData().then((clubs) => {
      axAPI.get("cms/info/allActiveSeason?leagueId=300").then((res) => {
        const seasons = res.data || [];
        if (seasons.length > 0) {
          const lastSeason = seasons.reduce(
            (latest: { seasonId: number }, current: { seasonId: number }) =>
              current.seasonId > latest.seasonId ? current : latest
          );
          setSeasonId(lastSeason.seasonId);
        }
      });
    });
  }, []);

  return (
    <List headerButtons={<></>} breadcrumb={false} title={"LEON B"}>
      <div style={{ color: "grey", fontSize: 12, paddingBottom: 16 }}>
        Данные нужно маппить в начале каждого сезона. Отображается список команд
        в LEON B.
        <br /> Нажать кнопку Смапить команду → Выбрать название команды в ФНЛ →
        Нажать кнопку Смапить команду
      </div>
      <Table<LeonBRowType>
        dataSource={datasource}
        rowClassName={(record, index, indent) =>
          !record.teamName ? s.needMapping : ""
        }
        pagination={false}
        loading={tableQueryResult.isFetching}
        rowKey={() => randomId()}
        locale={{
          emptyText: <div style={{ margin: 56 }}>Команды не найдены</div>,
        }}
        showSorterTooltip={false}
      >
        <Table.Column<LeonBRowType>
          width={100}
          title="Команда FNL"
          render={(_, record) => <TextField value={record?.teamName || "–"} />}
        />
        <Table.Column<LeonBRowType>
          width={100}
          title="Город команды FNL"
          render={(_, record) => <TextField value={record?.teamCity || "–"} />}
        />
        <Table.Column<LeonBRowType>
          width={100}
          title="Команда LEON 2Б"
          render={(_, record) => <TextField value={record.melbetTeam || "–"} />}
        />
        <Table.Column<LeonBRowType>
          width={40}
          title={"Действие"}
          align={"center"}
          render={(_, record) => (
            <MapTeam
              {...record}
              refetchList={fetchData}
              leagueTeam={leagueTeam}
            />
          )}
        />
      </Table>
    </List>
  );
};
